import api from '../services/api'

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        specimens: [],
        totalSpecimens: 0,
        disableDailyExtraction: false,
        saving: false,
        saveError: "",
        deleting: false,
        deleteError: ""
    },

    getters: {
        loadInProgress(state) {
            return state.loading;
        },
        getSpecimens(state) {
            return state.specimens;
        }
    },

    mutations: {
        setSpecimens(state, data) {
            state.specimens = data;
        },
        setTotalSpecimens(state, data) {
            state.totalSpecimens = data;
        },
        setDisableDailyExtraction(state, data) {
            state.disableDailyExtraction = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.specimens = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        },
        deleting(state) {
            state.deleting = true;
            state.deleteError = "";
        },
        deleteComplete(state) {
            state.deleting = false;
        },
        deleteError(state, err) {
            state.deleteError = err;
        },
        clearDeleteError(state) {
            state.deleteError = "";
        }
    },

    actions: {
        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        clearDeleteError(context) {
            context.commit("clearDeleteError");
        },
        saveSpecimen(context, options) {
            context.commit("saving");

            api.saveSpecimen(
                options.specimen, {
                    success: function(response) {
                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        loadSpecimens(context, options) {
            return new Promise(() => {
                context.commit("loading");
                api.fetchSpecimens({
                    params: options.params,
                    success: function(response) {
                        context.commit("setSpecimens", response.data.Specimens);
                        context.commit("setTotalSpecimens", response.data.TotalSpecimens);
                        context.commit("disableDailyExtraction", response.data.disableDailyExtraction);
                        if (options.success) {
                            options.success(response.data);
                        }
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("loadComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                });
            });
        },
        deleteSpecimen(context, options) {
            return new Promise(() => {
                context.commit("deleting");

                api.deleteSpecimen(
                    options.specimenID, {
                        success: function(response) {
                            if (options.success) {
                                options.success(response.data);
                            }
                        },
                        error: function(e) {
                            context.commit("deleteError", api.parseHttpRequestError(e));

                            if (options.error) {
                                options.error(e);
                            }
                        },
                        finally: function() {
                            context.commit("deleteComplete");

                            if (options.finally) {
                                options.finally();
                            }
                        }
                    });
            });
        },
        saveSpecimenLocation(context, options) {
            context.commit("saving");

            api.saveSpecimenLocation({
                SpecimenID: options.SpecimenID,
                LocationID: options.LocationID
            }, {
                success: function(response) {
                    if (options.success) {
                        options.success(response);
                    }
                },
                error: function(e) {
                    context.commit("saveError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function() {
                    context.commit("saveComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        }
    }
}